/**
 * etToolbox — serialisatie voor het toolbox-antwoordveld.
 *
 * Het toolbox-veld (EtToolbox.js) is een contentEditable met rijke snippets:
 * breuken (teller boven noemer), machten (sup), wortels en tabellen. Voor
 * opslag, nakijken en het antwoordmodel is een PLATTE tekstvorm nodig die
 * een docent/AI direct kan lezen: "3/4", "5^2", "√(16)", tabelrijen met "|".
 *
 * Pure DOM-wandeling, geen React — testbaar onder jsdom en herbruikbaar.
 */

export function toolboxNaarTekst(root) {
  if (!root) return '';

  function loop(node) {
    if (node.nodeType === 3) return node.textContent;           // tekstnode
    if (node.nodeType !== 1) return '';
    const el = node;
    const cls = el.classList || { contains: () => false };

    if (cls.contains('etx-breuk')) {
      const t = el.querySelector('.etx-teller');
      const n = el.querySelector('.etx-noemer');
      const tt = loop2(t), nn = loop2(n);
      if (!tt && !nn) return '';               // nooit ingevulde breuk: geen kale '/'
      return `${tt}/${nn}`;
    }
    if (el.tagName === 'SUP') {
      const inhoud = kinderen(el).trim();
      return inhoud ? `^${inhoud}` : '';       // lege macht: geen dangling '^'
    }
    if (cls.contains('etx-wortel')) {
      const inhoud = el.querySelector('.etx-wortel-inhoud');
      const ii = loop2(inhoud);
      return ii ? `√(${ii})` : '';             // lege wortel weglaten
    }
    if (el.tagName === 'TABLE') {
      const rijen = [];
      el.querySelectorAll('tr').forEach((tr) => {
        const cellen = [];
        tr.querySelectorAll('td,th').forEach((td) => cellen.push(kinderen(td).trim()));
        rijen.push(cellen.join(' | '));
      });
      return `\n${rijen.join('\n')}\n`;
    }
    if (el.tagName === 'BR') return '\n';
    // blok-elementen krijgen een regeleinde erna
    const blok = ['DIV', 'P'].includes(el.tagName);
    return kinderen(el) + (blok ? '\n' : '');
  }
  function kinderen(el) {
    let uit = '';
    el.childNodes.forEach((k) => { uit += loop(k); });
    return uit;
  }
  function loop2(el) { return el ? kinderen(el).trim() : ''; }

  return kinderen(root)
    .replace(/ /g, ' ')       // &nbsp;
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}
